/* eslint-disable prettier/prettier */
/* eslint-disable */
import Container from "@mui/material/Container";
import Grid from "@mui/material/Grid";
import Card from "@mui/material/Card";

// Material Kit 2 React components
import MKBox from "components/MKBox";
import MKTypography from "components/MKTypography";
import DefaultNavbar from "examples/Navbars/DefaultNavbar";
import Footer from "footer.routes";
import routes from "routes";
import { useRef, useEffect } from "react";
import { useInView } from 'react-intersection-observer';



// Images
import bgImage from "assets/images/om-oss/t-event-om-oss-bg.jpg"; // Bakgrunnsbilde
import logo from "assets/images/logos/T-event/fulllogo_transparent.png";
//import teamImage from "assets/images/om-oss/team/teamphoto.jpg"; // Bytt til bilde av teamet
//import MathiasImage from "assets/images/om-oss/team/mathias.png"; // Bilde av Mathias
//import MariusImage from "assets/images/om-oss/team/marius.png"; // Bilde av Marius
import TeamImage from "assets/images/om-oss/team/t-event-boss-img.jpg"; // Bilde av begge
import visjon from "assets/images/om-oss/t-event-vaar-visjon.jpg"; // Bilde for visjon
import historie from "assets/images/om-oss/t-event-vaar-historie.jpg"; // Bilde for historie
import team from "assets/videos/video-compressed.mp4"; // Bilde for team

import useScrollFadeIn from "hooks/useScrollFadeIn";
import useFadeInOnLoad from "hooks/useFadeInOnLoad"; // Ny hook for fade-in on load

function OmOss() {

  const videoRef = useRef(null);
  const { ref, inView } = useInView({
    triggerOnce: true, // Trigger animasjonen kun første gang elementet vises
    threshold: 0.5, // Trigger animasjon når 50% av elementet er synlig
  });

  useEffect(() => {
    if (inView && videoRef.current) {
      // Når videoen er synlig, kan du legge til parallax-effekten her
      videoRef.current.style.transform = "translateY(0px)";
    }
  }, [inView]);
  
  const logoRef = useFadeInOnLoad(0.3);
  const headingRef = useFadeInOnLoad(0.6);
  const subheadingRef = useFadeInOnLoad(0.9);
   const teaminfoRef = useScrollFadeIn();
   const visionRef = useScrollFadeIn();


  const sections = [
    {
      title: "Vår Visjon",
      text: "Vi ønsker å være den foretrukne leverandøren av lyd, lys og DJ-tjenester på Helgeland – uansett om det er en intim familiefest eller et stort arrangement. Målet er alltid det samme: at ditt event blir akkurat slik du ønsket det.",
      image: visjon, // Bilde for denne seksjonen
      reverseOrder: false, // Bestemmer om tekst eller bilde kommer først
    },
    {
      title: "Vår Historie",
      text: "T-Event ble etablert for å tilby profesjonelt lyd- og lysutstyr til alle typer arrangementer i regionen. Vi samarbeider tett med Eprod Mo i Rana for å sikre tilgang til topp utstyr, og har over tid bygget et godt rykte for pålitelig levering og høy kvalitet – arrangement etter arrangement. I tillegg til oppdrag for andre hoster vi egne events, med vellykkede kvelder som takeover på uteplasser og Halloween-rave på Park22 på merittlisten.",
      image: historie, // Bilde for denne seksjonen
      reverseOrder: true, // Denne seksjonen viser bilde først
    },
    // Flere seksjoner kan legges til her senere
  ];


  return (
    
    <>
      <DefaultNavbar routes={routes} />
      
      {/* HERO SECTION */}
      <MKBox
          minHeight="100vh"
          width="100%"
          position="relative"
          sx={{
            backgroundImage: `url(${bgImage})`,
            backgroundSize: "cover",  // Sørger for at bildet dekker hele området
            backgroundPosition: { xs: "center center", sm: "center center", md: "center center" },  // Bildet er alltid sentrert
            backgroundAttachment: { xs: "scroll", md: "fixed" },
            backgroundRepeat: "no-repeat",
            display: "grid",
            placeItems: "center",
            overflow: "hidden",
          }}
        >

        {/* Mørkt overlay over bakgrunnsbildet */}
        <MKBox
          sx={{
            position: "absolute",
            top: 0,
            left: 0,
            width: "100%",
            height: "100%",
            background: "rgba(0, 0, 0, 0.6)", // Mørkere bakgrunn
            zIndex: 1,
          }}
        />
        <Container sx={{ position: "relative", zIndex: 3, textAlign: "center" }}>
          <Grid container direction="column" alignItems="center" justifyContent="center" xs={12} lg={7} mx="auto">
   
            {/* Logo fades inn ved sidens load */}
            <MKBox ref={logoRef} component="img" src={logo} alt="T-Events Logo" width={{ xs: "200px", sm: "250px", md: "350px" }} mb={2} sx={{
              filter: "brightness(0) invert(1)",
              display: "block",
              mx: "auto",
              marginTop: { xs: "40px", md: "80px" },
            }} />

            {/* Overskrift fades inn ved sidens load */}
            <MKTypography ref={headingRef} variant="h1" color="white" textAlign="center" px={{ xs: 4, lg: 10 }} mt={1} sx={{
              fontSize: { xs: "28px", sm: "36px", md: "42px" },
              fontWeight: 200,
            }}>

              OM OSS
              </MKTypography>

            {/* Undertekst fades inn ved sidens load */}
            <MKTypography ref={subheadingRef} variant="h5" color="white" textAlign="center" px={{ xs: 4, lg: 10 }} mt={1} sx={{ 
              fontSize: '18px',                 
              fontFamily: "'Montserrat', sans-serif",
              fontWeight: 300,
            }}>
              Vi er T-Event – din samarbeidspartner for lyd, lys og uforglemmelig stemning på Helgeland!
            </MKTypography>
          </Grid>
        </Container>
      </MKBox>

      {/* TEAM INFO */}
      <Card ref={teaminfoRef} sx={{ p: 2, mx: { xs: 2, lg: 3 }, mt: -6, mb: 4, position: "relative", zIndex: 4 }}>

          <MKBox py={6} sx={{ textAlign: "center", backgroundColor: "white" }}>
            <Container>
              <Grid container spacing={4} justifyContent="center">
                <Grid item xs={12} md={8}>
                  <Card
                    sx={{
                      p: 4,
                      borderRadius: "16px",
                      boxShadow: "0 10px 30px rgba(0,0,0,0.1)",
                      textAlign: "center",
                      background: "rgba(255, 255, 255, 0.7)",
                      backdropFilter: "blur(10px)",
                      transition: "0.3s",
                      "&:hover": {
                        boxShadow: "0 15px 40px rgba(0,0,0,0.2)",
                      },
                    }}
                  >
                    {/* Team-bilde */}
                    <MKBox
                      component="img"
                      src={TeamImage} // Sett inn bilde av Mathias & Marius
                      alt="Mathias & Marius"
                      width="100%"
                      borderRadius="16px"
                      mb={3}
                      sx={{
                        boxShadow: "0 4px 20px rgba(0,0,0,0.1)",
                        "&:hover": { boxShadow: "0 6px 30px rgba(0,0,0,0.2)" },
                      }}
                    />

                    {/* Tekstinnhold */}
                    <MKTypography variant="h5" color="primary" fontWeight="bold" mb={1}>
                      Mathias & Marius
                    </MKTypography>
                    <MKTypography color="textSecondary" fontSize="18px" mb={2}>
                      To engasjerte folk med lidenskap for gode arrangement.
                    </MKTypography>

                    {/* Individuelle beskrivelser */}
                    <Grid container spacing={2}>
                      <Grid item xs={12} md={6}>
                        <MKBox p={2}>
                          <MKTypography variant="h6" fontWeight="bold">
                            Mathias Tustervatn
                          </MKTypography>
                          <MKTypography color="textSecondary" fontSize="16px">
                            Mathias er grunnleggeren av T-Event og tar seg av alt fra kundekontakt og planlegging til DJ-ing, rigging og teknisk utføring. Med bred erfaring innen lyd, lys og arrangement er han garantisten for at alt går som det skal – fra første henvendelse til siste beat.
                          </MKTypography>
                        </MKBox>
                      </Grid>
                      <Grid item xs={12} md={6}>
                        <MKBox p={2}>
                          <MKTypography variant="h6" fontWeight="bold">
                            Marius Hågensen
                          </MKTypography>
                          <MKTypography color="textSecondary" fontSize="16px">
                            Marius er en fast og viktig del av T-Event og bidrar på de fleste oppdrag. Han er DJ, rigger og tar seg av det tekniske – en uunnværlig del av teamet når det gjelder å levere arrangement av høy kvalitet.
                          </MKTypography>
                        </MKBox>
                      </Grid>
                    </Grid>
                  </Card>
                </Grid>
              </Grid>
            </Container>
          </MKBox>

      </Card>

        {/* TEAM VIDEO SECTION */}
        <MKBox
          py={6}
          sx={{
            marginTop: "-80px", // Juster top-margin hvis nødvendig
            position: "relative",
            overflow: "hidden",
            color: "white",
            textAlign: "center",
            minHeight: "70vh", // Sørg for at videoen har god høyde
            display: "flex",
            alignItems: "center", // Sentrerer vertikalt
            justifyContent: "center", // Sentrerer horisontalt
            "@media (max-width: 768px)": {
              minHeight: "50vh", // Mindre høyde på mobil
            },
          }}
        >
          {/* Bakgrunnsvideo med Parallax-effekt */}
          <video
            ref={videoRef}
            autoPlay
            loop
            muted
            playsInline
            style={{
              position: "absolute",
              top: 0, // Setter videoen til å starte på toppen av containeren
              left: 0, // Setter videoen til å starte på venstre side
              width: "100%", // Sørger for at videoen dekker hele bredden
              height: "100%", // Sørger for at videoen dekker hele høyden
              objectFit: "cover", // Sørger for at videoen dekker hele området
              zIndex: 0, // Sett videoen bak innholdet
              willChange: "transform", // Optimalisering for parallax-effekten
              transition: "transform 0.6s ease-out", // Legg til en overgang for jevn parallax
            }}
          >
            <source src={team} type="video/mp4" />
            Din nettleser støtter ikke video.
          </video>

          {/* Mørkt overlay */}
          <MKBox
            sx={{
              position: "absolute",
              top: 0,
              left: 0,
              right: 0,
              bottom: 0,
              backgroundColor: "rgba(0, 0, 0, 0.7)", // Mørkere filter
              zIndex: 1,
            }}
          />

          {/* Tekstinnhold */}
          <Container
            ref={ref} // Bruk inView på Container for fade-in
            sx={{
              position: "relative",
              zIndex: 2,
              py: 4,
              opacity: inView ? 1 : 0, // Fade-in når teksten er synlig
              transform: inView ? "translateY(0)" : "translateY(20px)", // Animasjonseffekt for tekst
              transition: "opacity 0.6s ease, transform 0.6s ease", // Effekt for tekstfade og bevegelse
            }}
          >
            <MKTypography
              variant="h5"
              color="white"
              fontWeight="bold"
              mb={2}
              sx={{
                fontSize: { xs: 'h6', sm: 'h5' },
              }}
            >
              Møt Vårt Team
            </MKTypography>
            <MKTypography
              color="white"
              fontSize={{ xs: '16px', sm: '18px' }}
              sx={{
                lineHeight: 1.6,
                pt: 2, // Padding-top for å gi mer plass øverst
              }}
            >
              Vi er to engasjerte folk med lidenskap for gode arrangement, og vi strekker oss alltid det lille ekstra for at ditt event skal bli akkurat slik du ønsket det. Med bred erfaring innen lyd, lys, DJ og teknisk utføring er vi klare til å håndtere alt fra store produksjoner til intime fester.
            </MKTypography>
          </Container>
        </MKBox>





        {/* SEKSJONER FOR VISJON OG HISTORIE */}
        <Card ref={visionRef} sx={{ p: 2, mx: { xs: 2, lg: 3 }, mt: -6, mb: 4, position: "relative", zIndex: 4 }}>

          {/* Dynamisk generering av seksjoner Visjon og Historie */}
          {sections.map((section, index) => (
            <MKBox py={6} sx={{ backgroundColor: index % 2 === 0 ? "#ffffff" : "#ffffff", textAlign: 'center' }} key={index}>
              <Container>
                <Grid container spacing={4} justifyContent="center">
                  {/* Hvis reverseOrder er true, bytt rekkefølge på tekst og bilde */}
                  {!section.reverseOrder ? (
                    <>
                      <Grid item xs={12} md={5} sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
                        <MKTypography variant="h5" color="primary" fontWeight="bold" mb={3}>
                          {section.title}
                        </MKTypography>
                        <MKTypography color="textSecondary" fontSize="18px" textAlign="center">
                          {section.text}
                        </MKTypography>
                      </Grid>

                      <Grid item xs={12} md={5} sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
                        <MKBox
                          component="img"
                          src={section.image}
                          alt={section.title}
                          width="100%"
                          borderRadius="12px"
                          sx={{
                            boxShadow: '0 4px 20px rgba(0,0,0,0.1)',
                          }}
                        />
                      </Grid>
                    </>
                  ) : (
                    <>
                      <Grid item xs={12} md={5} sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
                        <MKBox
                          component="img"
                          src={section.image}
                          alt={section.title}
                          width="100%"
                          borderRadius="12px"
                          sx={{
                            boxShadow: '0 4px 20px rgba(0,0,0,0.1)',
                          }}
                        />
                      </Grid>

                      <Grid item xs={12} md={5} sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
                        <MKTypography variant="h5" color="primary" fontWeight="bold" mb={3}>
                          {section.title}
                        </MKTypography>
                        <MKTypography color="textSecondary" fontSize="18px" textAlign="center">
                          {section.text}
                        </MKTypography>
                      </Grid>
                    </>
                  )}
                </Grid>
              </Container>
            </MKBox>
          ))}
          </Card>

      {/* FOOTER */}
      <MKBox pt={6} px={1} mt={6}>
        <Footer />
      </MKBox>
    </>
  );
}

export default OmOss;
